import axios from 'axios';

import {
  FETCH_DISPUTES,
  START_FETCH_DISPUTES_LOADER,
  FETCH_DISPUTE_MESSAGES,
  START_FETCH_MESSAGES_LOADER,
  SEND_DISPUTE_MESSAGE,
  CONFIRM_DISPUTE_MESSAGE,
  FETCH_SINGLE_DISPUTE,
  FETCH_SINGLE_DISPUTE_LOADING,
  ACCEPT_TERMS_AND_CONDITIONS
} from './reducer';
import { getCookieValues } from '../../utilities/helpers';

const disputesRequest = () => {
  const [houseRef] = getCookieValues(['houseRef']);
  return axios.create({
    withCredentials: true,
    headers: {
      Authorization: `${houseRef}*`
    }
  });
};

const sortDisputesByDate = (disputes, isDescending) =>
  disputes.sort(({ disputeInfo: disputeInfoA }, { disputeInfo: disputeInfoB }) => {
    const dateA = disputeInfoA.disputeDate.time;
    const dateB = disputeInfoB.disputeDate.time;
    return isDescending ? dateB - dateA : dateA - dateB;
  });
export const fetchDisputesData = (disputeParams, houseRef) => async dispatch => {
  try {
    dispatch({ type: START_FETCH_DISPUTES_LOADER });
    const {
      data: { data = {} }
    } = await disputesRequest().get(`/app/house/${houseRef}/${disputeParams}`);

    dispatch({
      type: FETCH_DISPUTES,
      payload: sortDisputesByDate(data.disputes || [])
    });
  } catch (e) {
    console.error(e.error);
    dispatch({ type: START_FETCH_DISPUTES_LOADER, payload: false });
  }
};

export const fetchDisputeMessages = (
  houseRef,
  disputeRef,
  showLoader,
  callback
) => async dispatch => {
  try {
    if (showLoader) dispatch({ type: START_FETCH_MESSAGES_LOADER });
    const {
      data: { data = {} }
    } = await disputesRequest().get(`/app/house/${houseRef}/dispute/messages/${disputeRef}`);
    dispatch({
      type: FETCH_DISPUTE_MESSAGES,
      payload: data.messages || []
    });
    if (callback) callback();
  } catch (e) {
    console.error(e.error);
    dispatch({ type: START_FETCH_MESSAGES_LOADER, payload: false });
  }
};

export const confirmSendDisputeMessage = (houseRef, payload, callback) => async dispatch => {
  try {
    const {
      data: { data = {} }
    } = await disputesRequest().post(`/app/house/${houseRef}/disputes/`, payload);
    callback();
    dispatch({
      type: CONFIRM_DISPUTE_MESSAGE,
      payload: data
    });
  } catch (e) {
    console.error(e.error);
  }
};

export const sendDisputeMessage = (houseRef, disputeRef, payload, callback) => async dispatch => {
  try {
    const {
      data: { data = {} }
    } = await disputesRequest().post(`/app/house/${houseRef}/disputes/`, payload);
    dispatch(
      fetchDisputeMessages(houseRef, disputeRef, false, () => {
        callback();
        dispatch({
          type: SEND_DISPUTE_MESSAGE,
          payload: data
        });
      })
    );
  } catch (e) {
    console.error(e.error);
  }
};

export const fetchSingleDispute = (houseRef, disputeId, callback) => async dispatch => {
  try {
    dispatch({
      type: FETCH_SINGLE_DISPUTE_LOADING
    });
    const {
      data: { data = {} }
    } = await disputesRequest().get(`/app/house/${houseRef}/dispute/${disputeId}`);
    if (callback) callback();
    dispatch({
      type: FETCH_SINGLE_DISPUTE,
      payload: data.dispute || {}
    });
  } catch (e) {
    console.error(e.error);
  }
};

export const acceptTermsAndConditionRequest = (houseRef, callback) => async dispatch => {
  try {
    const {
      data: { data = {} }
    } = await disputesRequest().post(`/app/house/${houseRef}/acceptDisputeTerms`, {
      accepted: true
    });
    dispatch({
      type: ACCEPT_TERMS_AND_CONDITIONS,
      payload: data
    });
    callback(data);
  } catch (e) {
    console.error(e.error);
  }
};
